<template>
  <b-card class="m-4">
    <b-tabs card pills>
      <b-tab active title="Edit Info">
        <b-card-text>
          <div class="form-group">
            <label>Type</label>
            <input class="form-control" type="text" v-model="title" />
          </div>
          <div class="form-group">
            <label>Body</label>
            <input class="form-control" type="text" v-model="body" />
          </div>
          <div class="form-group">
            <label>Hour</label>
            <input
              class="form-control"
              type="number"
              v-model="hour"
              max="24"
              min="0"
            />
          </div>
          <div class="form-group">
            <label>Minute</label>
            <input
              class="form-control"
              type="number"
              v-model="minute"
              max="60"
              min="0"
            />
          </div>
          <div class="form-group">
            <label>Status</label>
            <select v-model="status" class="form-control">
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          <div class="form-group">
            <label>Upload Image</label>
            <input
              class="form-control"
              type="file"
              v-on:change="onImageChange"
            />
          </div>

          <CButton @click="onSubmit" color="primary">
            <CIcon name="cil-check-circle" />Edit Schedule Notification
          </CButton>
        </b-card-text>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import axios from "axios";
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const BASE_URL = "https://quizgiri.s3.ap-south-1.amazonaws.com/p";
export default {
  name: "editScheduleNotification",
  data() {
    return {
      noti_id: "",
      body: "",
      title: "",
      hour: "",
      minute: "",
      banner: "",
      status: "",

      scheduleNoti: [],
      isActive: null,
      isDisabled: true,
    };
  },
  created() {
    this.noti_id = this.$route.params.id;
    console.log("popup id", this.noti_id);
    this.getOld();
  },
  methods: {
    getOld() {
      axios
        .get(`${ADMIN_URL}/schedule-notification/item/${this.noti_id}`)
        .then((response) => {
          this.scheduleNoti = response.data.data;
          // console.log(this.scheduleNoti);
          this.title = this.scheduleNoti.title;
          console.log("title", this.title);
          this.body = this.scheduleNoti.body;
          this.hour = this.scheduleNoti.hour;
          this.minute = this.scheduleNoti.minute;
          this.banner = this.scheduleNoti.banner;
          this.status = this.scheduleNoti.status;

          // console.log('redeem id data',this.scheduleNoti);
        })
        .catch((e) => {
          console.log("error occurs", e.response);
        });
    },
    onImageChange(e) {
      this.banner = e.target.files[0];
    },
    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
      formData.append("title", this.title);
      formData.append("body", this.body);
      formData.append("hour", this.hour);
      formData.append("minute", this.minute);
      formData.append("status", this.status);
      formData.append("banner", this.banner);

      const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
      // console.log("Formdata",formData);

      axios
        .post(
          `${ADMIN_URL}/schedule-notification/update/${this.noti_id}`,
          formData
        )
        .then((response) => {
          console.log("Success", response);

          return this.$router.push("/schedule-notification");
        })
        .catch((error) => {});
    },
  },
};
</script>

<style scoped></style>
